import React from 'react';
interface LogoProps {
  className?: string;
  light?: boolean;
}
export function Logo({
  className = 'h-8',
  light = false
}: LogoProps) {
  const textColor = light ? 'text-white' : 'text-navy';
  const accentColor = light ? 'text-electric-light' : 'text-electric';
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-231">
      <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-full w-auto" data-id="element-232">
        {/* Shield Base */}
        <path d="M20 2L4 8V18C4 27.5 10.8 36.2 20 39C29.2 36.2 36 27.5 36 18V8L20 2Z" fill="currentColor" fillOpacity="0.1" className={accentColor} data-id="element-233" />
        <path d="M20 2L4 8V18C4 27.5 10.8 36.2 20 39C29.2 36.2 36 27.5 36 18V8L20 2Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" className={accentColor} data-id="element-234" />
        {/* Circuit 'D' Monogram */}
        <path d="M14 12V28M14 12H20C24.4183 12 28 15.5817 28 20C28 24.4183 24.4183 28 20 28H14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={textColor} data-id="element-235" />
        {/* Circuit Nodes */}
        <circle cx="14" cy="12" r="2" fill="currentColor" className={accentColor} data-id="element-236" />
        <circle cx="14" cy="28" r="2" fill="currentColor" className={accentColor} data-id="element-237" />
        <circle cx="28" cy="20" r="2" fill="currentColor" className={accentColor} data-id="element-238" />
        <path d="M28 20H32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" className={accentColor} data-id="element-239" />
      </svg>
      <span className={`font-bold text-xl tracking-tight ${textColor}`} data-id="element-240">
        DAB<span className={accentColor} data-id="element-241">.</span>
      </span>
    </div>;
}